var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small-text"},[_vm._v(" "+_vm._s(_vm.dateText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }